import React from "react";
import PropTypes from "prop-types";
import {withStyles} from "@mui/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Paper from "@mui/material/Paper";
import Tooltip from "@mui/material/Tooltip";
import download from '../reports/images/download-doc.svg';
import "react-daterange-picker/dist/css/react-calendar.css";
import Divider from '@mui/material/Divider';
import Avatar from "@mui/material/Avatar";
import "date-fns";
import spinner from '../assign-prescriptions/images/spinner.gif';
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import {IconButton, Box, Grid} from "@mui/material";
import enLocale from "date-fns/locale/en-US";
import frLocale from "date-fns/locale/fr";

import moment from 'moment-timezone';
import {withTranslation} from "react-i18next";
import ILocalAGGrid, {
  getDefaultColDef,
  createServerSideDatasource,
  withDateColumnFilter,
  applyReportFilterModel,
  attachReportServerSideDatasource,
} from "../grid/iLocalAGGrid";
import getTypeByLang from "../common/typeByLang";
import {
  getDefaultDateRange,
  formatFromDateForAPI,
  formatToDateForAPI,
} from "../../utils/datetime.utils";


class EnhancedTableHead extends React.Component {
  createSortHandler = (property, field) => event => {
    this.props.onRequestSort(event, property, field);
  };

  render() {
    const {order, orderBy, sortId, t} = this.props;
    const rows = [
      { id: "firstname", numeric: false, disablePadding: false, label: t("Report.OutForDelivery.FirstName"), padding: '10px', field: 'first_name' },
      { id: "lastname", numeric: false, disablePadding: false, label: t("Report.OutForDelivery.LastName"), padding: '10px', field: 'last_name' },
      { id: "store", numeric: false, disablePadding: false, label: t("Report.OutForDelivery.Store"), padding: '10px', field: 'name' },
      { id: "box", numeric: false, disablePadding: false, label: t("Report.OutForDelivery.Location"), padding: '10px', field: 'name' },
      { id: "deliverytype", numeric: false, disablePadding: false, label: t("Report.OutForDelivery.DeliverType"), padding: '10px', field: 'name' },
      { id: "rxno", numeric: false, disablePadding: false, label: t("Report.OutForDelivery.RxHash"), padding: '10px', field: 'rx_no' },
      { id: "fillid", numeric: false, disablePadding: false, label: t("Report.OutForDelivery.FillID"), padding: '10px', field: 'fill_id' },
      { id: "prescriptionnumber", numeric: false, disablePadding: false, label: t("Report.OutForDelivery.PrescriptionNumber"), padding: '10px', field: 'prescriptionnumber' },
      { id: "pucode", numeric: false, disablePadding: false, label: t("Report.OutForDelivery.PUCode"), padding: '10px', field: 'pucode' },
      { id: "ndccode", numeric: false, disablePadding: false, label: t("Report.OutForDelivery.NDCCode"), padding: '10px', field: 'ndc_code' },
      { id: "drugname", numeric: false, disablePadding: false, label: t("Report.OutForDelivery.DrugName"), padding: '10px', field: 'drug_name' },
      { id: "qty", numeric: false, disablePadding: false, label: t("Report.OutForDelivery.Qty"), padding: '10px', field: 'qty' },
      { id: "price", numeric: false, disablePadding: false, label: t("Report.OutForDelivery.AmountDue"), padding: '10px', field: 'price' },
      { id: "Consult", numeric: false, disablePadding: false, label: t("Report.OutForDelivery.Consult"), padding: '10px', field: 'is_consult_requested' },
      { id: "Transaction Date", numeric: false, disablePadding: false, label: t("Report.OutForDelivery.TransactionDate"), padding: '10px', field: 'created_on' },
      { id: "User", numeric: false, disablePadding: false, label: t("Report.OutForDelivery.User"), padding: '10px', field: 'name' },
    ];

    return (
      <TableHead>
        <TableRow>
          {rows.map(row => {
            return (
              <TableCell
                key={row.id}
                numeric={row.numeric}
                padding={row.disablePadding ? "none" : "default"}
                sortDirection={orderBy === row.id ? order : false}
                style={{ padding: row.padding, color: 'rgba(0, 0, 0, 0.54)' }}
              >
                {[
                  "store",
                  "deliverytype",
                  "fillid",
                  "prescriptionnumber",
                  "ndccode",
                  "qty",
                  "price",
                ].includes(row.id) ? (
                  <TableSortLabel style={{ cursor: "text" }}>{row.label}</TableSortLabel>
                ) : (
                  <Tooltip
                    title={t("Global.Label.Filter.Sort")}
                    placement={row.numeric ? "bottom-end" : "bottom-start"}
                    enterDelay={300}
                  >
                    <TableSortLabel
                      active={orderBy === row.field && sortId === row.id}
                      direction={order}
                      onClick={this.createSortHandler(row.id, row.field)}
                    >
                      {row.label}
                    </TableSortLabel>
                  </Tooltip>
                )}
              </TableCell>
            );
          }, this)}
        </TableRow>
      </TableHead>
    );
  }
}

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  sortId: PropTypes.string.isRequired
};
EnhancedTableHead = withTranslation()(EnhancedTableHead);

const styles = theme => ({
  root: {
    width: "100%",
  },
  table: {
    minWidth: 1020
  },
  tableWrapper: {
    overflowX: "auto"
  },
  dob: {
    paddingTop: '25px',
  },
  headerdiv: {
    paddingLeft: '15%',
    paddingTop: '10'
  },
  padding10px: {
    padding: '10px'
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
    maxWidth: 390,
  },
  logoWrapper:
  {
    position: 'absolute',
    width: '89%',
    height: '70%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: 'rgba(255,255,255,0.5)',
    zIndex: '7869'
  },
  spinner: {
    position: 'absolute',
    background: 'rgba(255,255,255,.4)',
    width: '100%',
    height: '100%',
    zIndex: '9999',
    top: 0,
    left: 0,
  },
  spinnerImage: {
    top: 'calc(50% - 32.5px)',
    left: 'calc(50% - 65px)',
    position: 'absolute',
    width: '130px',
    userSelect: 'none'
  },
  hidden: {
    display: 'none'
  },
  rowheight: {
    height: '35px'
  },
  primaryButton: {
    background: '#6cca98',
    color: '#fff',
    '&:hover': {
      background: '#6cca98',
      color: '#fff',
    },
    '&:disabled': {
      color: 'rgba(0, 0, 0, 0.38)',
      cursor: 'not-allowed',
      background: '#E4E5E8'
    },
  }
});

const __reportDefaultDates = getDefaultDateRange();

let TransactionFilterObj = {
  store_ids: [],
  box_ids: [],
  searchtext: '',
  fromdate: formatFromDateForAPI(__reportDefaultDates.fromDate),
  todate: formatToDateForAPI(__reportDefaultDates.toDate),
  pageNo: 0,
  pageSize: 10,
  sortOrder: 'desc',
  sortColumn: 'created_on',
  tableName: '',
  group_id: null,
  timezone: ''
}

const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
const findOffset = moment().tz(timeZone).utcOffset();
const defaultZone = `(UTC ${findOffset}) ${timeZone}`;

class OutOfDelivery extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      order: "desc",
      dob: '',
      orderBy: "created_on",
      page: 0,
      rowsPerPage: 10,
      searchtext: '',
      store_id: [],
      box_id: [],
      fromdate: null,
      todate: null,
      dateRangePreset: 'last7days',
      isOpen: false,
      stores: [],
      boxes: [],
      boxvalues: [],
      accountValues: [],
      nstores: [],
      nboxes: [],
      chipstores: [],
      chipboxes: [],
      loader: false,
      selectedObject: null,
      isDataEmpty: true,
      totalRecords: 0,
      isButtonDisabled: false,
      locale: localStorage.getItem('i18nextLng') === 'en' ? enLocale : frLocale,
      queryId: "",
      groups: [],
    };
    this.handleStoreChange = this.handleStoreChange.bind(this);
    this.handleBoxChange = this.handleBoxChange.bind(this);
    this.debouceTimeout = null;
  }

  refreshGrid = () => {
    if (!this.gridApi) return;
    if (typeof this.gridApi.refreshServerSideStore === "function") {
      this.gridApi.refreshServerSideStore({ purge: true });
    } else if (typeof this.gridApi.refreshServerSide === "function") {
      this.gridApi.refreshServerSide({ purge: true });
    }
  };

  getRowId = (params) => {
    const d = params.data || {};
    if (d.__ssrmId) return String(d.__ssrmId);
    return [
      d.prescription_txn_id,
      d.order_id,
      d.pmid,
      d.rxno,
      d.fillid,
      d.transaction_date,
      d.pucode,
      d.store,
      d.box,
    ]
      .filter((v) => v != null && String(v).trim() !== '')
      .join('|') || `row-${Math.random().toString(36).slice(2)}`;
  };

  onRowSelected = (params) => {
    if (!params || !params.api) return;
    const selectedNodes = params.api.getSelectedNodes() || [];
    this.setState({
      selected: selectedNodes
        .map((n) => n.data && (n.data.id || n.data.ID))
        .filter(Boolean),
    });
  };

  onPaginationChanged = (params) => {
    if (!params.api) return;
    const newPageSize = params.api.paginationGetPageSize();
    const body = this._agFilterBody;
    if (body && newPageSize && body.pageSize !== newPageSize) {
      body.pageSize = newPageSize;
    }
  };

  componentDidMount() {
    // Get user's timezone for date filtering
    let userTimeZone = sessionStorage.getItem('timeZone');
    if (['null', null, 'undefined', undefined, ''].includes(userTimeZone)) {
      userTimeZone = defaultZone;
    }
    TransactionFilterObj.timezone = userTimeZone.substring(userTimeZone.lastIndexOf(' ') + 1);

    TransactionFilterObj.group_id = sessionStorage.getItem("groupID");
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + "accounts", {
      method: 'GET',
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
        'Content-Type': 'application/json'
      }
    })
      .then(response => response.json())
      .then(accounts => {
        const {t} = this.props;
        let All = [{ id: "-1", name: t("Global.Label.DropDown.All") }]
        const storelist = accounts.map(account => {
          return { id: account.id, name: account.name };
        });

        const accountValues = All.concat(storelist);
        this.setState({ accountValues, parent_account_id: accountValues[0].id });
        this.BindBoxesbyStoreId(storelist.map(x => x.id));
        this.setState({ loader: false });
      });

    // Mutate in place — SSRM datasource holds a reference to this object.
    const defaultDates = getDefaultDateRange();
    this.setState({
      fromdate: defaultDates.fromDate,
      todate: defaultDates.toDate,
      dateRangePreset: 'last7days',
    });
    TransactionFilterObj.store_ids = [];
    TransactionFilterObj.box_ids = [];
    TransactionFilterObj.searchtext = '';
    TransactionFilterObj.fromdate = formatFromDateForAPI(defaultDates.fromDate);
    TransactionFilterObj.todate = formatToDateForAPI(defaultDates.toDate);
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.pageSize = 10;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'created_on';
    TransactionFilterObj.tableName = '';

    this.fetchSuggestions();
  }

  convertToTimeZone = (requestDate) => {
    const currentUserLang = localStorage.getItem('i18nextLng');
    let zone;
    zone = sessionStorage.getItem('timeZone');
    const date = moment(new Date(requestDate));
    if (['null', null, 'undefined', undefined].includes(zone)) {
      zone = defaultZone;
    }
    return currentUserLang === 'en' ? date.tz(zone.substring(zone.lastIndexOf(' ') + 1)).format('MM/DD/YYYY hh:mm:ss A') : date.tz(zone.substring(zone.lastIndexOf(' ') + 1)).format('DD/MM/YYYY hh:mm:ss A');
  }

  exportCSV() {
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + 'CSV/OutForDeliveryReport', {
      method: 'POST',
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(TransactionFilterObj)
    })
      .then(response => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then(csvData => {
        this.setState({ loader: false });
        let csvRow = [];
        let Array = [['StoreID', 'FirstName', 'LastName', 'Store', 'Box', 'BIN', 'RxNo', 'Fill ID', 'Prescription Number', 'StockCode', 'PickUpCode', 'NDC Code', 'Drug Name', 'Qty', 'Amount Due', 'Fill Date', 'Stock Date', 'Pick Up Date']];
        let result = csvData && csvData.Results && csvData.Results.length > 0 ? csvData.Results : [];
        if (result !== undefined && result !== 'undefined') {
          if (result && result.length > 0) {
            for (let i of result) {
              Array.push(
                [
                  i.firstname,
                  i.lastname,
                  i.store,
                  i.box,
                  i.binid,
                  i.rxno,
                  i.fillid,
                  i.prescriptionnumber,
                  i.stock_code,
                  i.pucode,
                  i.ndccode,
                  i.drugname,
                  i.qty,
                  i.price ? '$' + parseFloat(i.price).toFixed(2) : '$0.00',
                  i.filldate ? this.convertToTimeZone(i && i.filldate) : '',
                  i.stockeddate ? this.convertToTimeZone(i && i.stockeddate) : '',
                  i.pickupdate ? this.convertToTimeZone(i && i.pickupdate) : '',
                ]
              );
            }

            for (let i of Array) {
              csvRow.push(i.join(","));
            }
            let csvString = csvRow.join("%0A");
            let element = document.createElement("a");
            element.href = 'data:attachment/csv.' + csvString;
            element.target = "_Blank";
            element.download = "OutForDeliveryReport.csv";
            document.body.appendChild(element);
            element.click();
          }
        }
      })
  };

  gettingOnSortTableName = (field) => {
    let tablename = '';
    if (['firstname', 'lastname'].includes(field)) {
      tablename = 'customers';
    }
    if (['box'].includes(field)) {
      tablename = 'boxes';
    }
    if (['rxno', 'drugname'].includes(field)) {
      tablename = 'prescription_detail';
    }
    if (['stock_code', 'pucode'].includes(field)) {
      tablename = 'prescriptions_master';
    }
    if (['User'].includes(field)) {
      tablename = 'users';
    }
    if (['Consult'].includes(field)) {
      tablename = 'customer_collect_detail';
    }
    if (['Transaction Date'].includes(field)) {
      tablename = 'events';
    }
    return tablename;
  }

  handleRequestSort = (event, property, field) => {
    const orderBy = property;
    let order = "desc";
    if (this.state.order === "desc") {
      order = "asc";
    }
    this.setState({ order, orderBy, sortId: property });
    TransactionFilterObj.sortOrder = order;
    TransactionFilterObj.sortColumn = field;
    TransactionFilterObj.tableName = this.gettingOnSortTableName(orderBy);
    
    if (this.state.data && this.state.data.length > 0) {
      this.BindGrid();
    }
  };
  handleChangePage = (event, page) => {
    event && event.preventDefault();
    
    TransactionFilterObj.pageNo = page;
    if (this.state.data && this.state.data.length > 0) {
      this.BindGrid();
    }
  };

  handleChangeRowsPerPage = event => {
    
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.pageSize = event.target.value;
    if (this.state.data && this.state.data.length > 0) {
      this.BindGrid();
    }
  };

  //Bind Boxes by store id
  onGridReady = (params) => {
    this.gridApi = params.api;
    this._agFilterBody = TransactionFilterObj;
    const datasource = createServerSideDatasource({
      filterBody: TransactionFilterObj,
      applyFilterModel: (body, filterModel) => {
        applyReportFilterModel(body, filterModel, {
          dateColIds: ['transaction_date'],
        });
      },
      pageZeroBased: true,
      getPageSize: () => TransactionFilterObj.pageSize || 10,
      fetchPage: (body) =>
        fetch(process.env.REACT_APP_BASEURL + 'deliveryreport/outofdelivery', {
          method: "post",
          withCredentials: true,
          headers: {
            Authorization:
              "Bearer " +
              JSON.parse(sessionStorage.getItem("user")).signInUserSession
                .idToken.jwtToken,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            ...body,
            store_ids: Array.isArray(body.store_ids) ? body.store_ids : [],
            box_ids: Array.isArray(body.box_ids) ? body.box_ids : [],
            fromdate: body.fromdate || '',
            todate: body.todate || '',
            searchtext: body.searchtext || '',
            timezone:
              body.timezone ||
              (() => {
                const stored = sessionStorage.getItem('timeZone');
                if (stored) return stored.substring(stored.lastIndexOf(' ') + 1);
                return Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
              })(),
          }),
        }).then((r) => r.json()),
      onSuccess: (results, total) => {
        setTimeout(() => {
          this.setState({
            data: results,
            totalRecords: total,
            loader: false,
            isDataEmpty: !results || results.length === 0,
            isButtonDisabled: !results || results.length === 0,
          });
        }, 0);
      },
      onError: () => this.setState({ loader: false }),
    });
    attachReportServerSideDatasource(
      params,
      datasource,
      TransactionFilterObj,
      'transaction_date'
    );
  };

  BindBoxesbyStoreId(store_ids) {
    if (store_ids.length > 0) {
      this.setState({ loader: true });
      let BoxesObj = {
        store_ids: store_ids
      }
      fetch(process.env.REACT_APP_BASEURL + 'getBoxesByStoreIds', {
        method: 'post',
        withCredentials: true,
        headers: {
          'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(BoxesObj)
      })
        .then(response => {
          try {
            return response.json();
          } catch (error) {
            return null;
          }
        })
        .then(data => {
          const {t} = this.props;
          let All = [{ id: "-1", name: t("Global.Label.DropDown.All") }]
          const boxlist = data.map(account => {
            return { id: account.id, name: account.name };
          });
          const boxvalues = All.concat(boxlist);
          this.setState({ chipboxes: [] });
          this.setState({ nboxes: [] });
          this.setState({ boxvalues: boxvalues });
          this.setState({ loader: false });
        });

    }

  }
  handleStoreChange = event => {
    const storeid = event.target.value;
    const storeids = [];
    let processed = [];
    let chipprocessed = [];
    const AllprocessedIndex = storeid.findIndex(x => x.id === '-1');
    if (event.target.value.length === 1 && AllprocessedIndex > -1) {
      const element = event.target.value[AllprocessedIndex];
      chipprocessed.push(element);
      for (let i = 0; i < this.state.accountValues.length; i++) {
        processed.push(this.state.accountValues[i]);
      }
    }
    else if (event.target.value.length > 0 && AllprocessedIndex > -1) {
      for (let i = 0; i < this.state.accountValues.length; i++) {
        const element = storeid.findIndex(x => x.id === this.state.accountValues[i].id);
        if (element > -1) {
        }
        else {
          chipprocessed.push(this.state.accountValues[i]);
          processed.push(this.state.accountValues[i]);
        }
      }
    }
    else if (storeid.length === 0 && AllprocessedIndex === -1) {
      chipprocessed = [];
      processed = [];
    }
    else if (storeid.length > 0) {
      for (let i = 0; i < event.target.value.length; i++) {
        const element = event.target.value[i];
        if (element.id !== '-1') {
          chipprocessed.push(element);
          processed.push(element);
        }
        else {

        }
      }
    }
    this.setState({ chipstores: chipprocessed });
    this.setState({ nstores: processed });

    if (processed.length > 0) {
      for (let i = 0; i < processed.length; i++) {
        if (processed[i].id !== '-1') {
          storeids.push(processed[i].id)
        }
      }
    }
    this.setState({ store_id: storeids });
    TransactionFilterObj.store_ids = storeids;
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'created_on';
    TransactionFilterObj.tableName = '';
    this.BindBoxesbyStoreId(storeids);
    this.BindGrid();
  };
  handleBoxChange = event => {
    const boxid = event.target.value;
    const boxids = [];

    let processed = [];
    let chipprocessed = [];
    const AllprocessedIndex = boxid.findIndex(x => x.id === '-1');
    if (event.target.value.length === 1 && AllprocessedIndex > -1) {
      const element = event.target.value[AllprocessedIndex];
      chipprocessed.push(element);
      for (let i = 0; i < this.state.boxvalues.length; i++) {
        processed.push(this.state.boxvalues[i]);
      }
    }
    else if (event.target.value.length > 0 && AllprocessedIndex > -1) {
      for (let i = 0; i < this.state.boxvalues.length; i++) {
        const element = boxid.findIndex(x => x.id === this.state.boxvalues[i].id);
        if (element > -1) {
        }
        else {
          chipprocessed.push(this.state.boxvalues[i]);
          processed.push(this.state.boxvalues[i]);
        }
      }
    }
    else if (boxid.length === 0 && AllprocessedIndex === -1) {
      chipprocessed = [];
      processed = [];
    }
    else if (boxid.length > 0) {
      for (let i = 0; i < event.target.value.length; i++) {
        const element = event.target.value[i];
        if (element.id !== '-1') {
          chipprocessed.push(element);
          processed.push(element);
        }
        else {

        }
      }
    }
    this.setState({ chipboxes: chipprocessed });
    this.setState({ nboxes: processed });

    if (processed.length > 0) {
      for (let i = 0; i < processed.length; i++) {
        if (processed[i].id !== '-1') {
          boxids.push(processed[i].id)
        }
      }
    }

    this.setState({ box_id: boxids });
    TransactionFilterObj.box_ids = boxids;
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'created_on';
    TransactionFilterObj.tableName = '';
    this.BindGrid();
  };
  //Search Text Box change event
  onSearchChange = (event) => {
    this.debouceTimeout && clearInterval(this.debouceTimeout);
    const searchString = event.target.value;
    this.setState({ searchtext: searchString && searchString });
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'created_on';
    TransactionFilterObj.tableName = '';
    TransactionFilterObj.searchtext = searchString;
    this.debouceTimeout = setTimeout(() => {
      this.BindGrid();
    }, 1000)
  }
  onFromDateSelect = date => {
    const dateObj = date ? moment(date) : null;
    this.setState({ fromdate: dateObj, dateRangePreset: '' });
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'created_on';
    TransactionFilterObj.tableName = '';
    TransactionFilterObj.fromdate = formatFromDateForAPI(dateObj);
    this.BindGrid();
  };
  onToDateSelect = date => {
    const dateObj = date ? moment(date) : null;
    this.setState({ todate: dateObj, dateRangePreset: '' });
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'created_on';
    TransactionFilterObj.tableName = '';
    TransactionFilterObj.todate = formatToDateForAPI(dateObj);
    this.BindGrid();
  };

  handleBlurfrom = (value, date) => {
    const dateObj = date ? moment(date) : null;
    this.setState({ fromdate: dateObj, dateRangePreset: '' });
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'created_on';
    TransactionFilterObj.tableName = '';
    TransactionFilterObj.fromdate = formatFromDateForAPI(dateObj);
    this.BindGrid();
  }
  handleBlurtodate = (value, date) => {
    const dateObj = date ? moment(date) : null;
    this.setState({ todate: dateObj, dateRangePreset: '' });
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'created_on';
    TransactionFilterObj.tableName = '';
    TransactionFilterObj.todate = formatToDateForAPI(dateObj);
    this.BindGrid();
  }

  BindGrid = () => {
    if (this.gridApi) {
      this.refreshGrid();
      return;
    }
    // SSRM datasource is attached in onGridReady; avoid a parallel
    // legacy fetch/setState race that leaves the grid on Please Wait...
    this.setState({ loader: false });
  };

  handlePUcodeClick = (event, pmid) => {
    event.preventDefault();
    const selectedObject = this.state.data.find(x => x.pmid === pmid);
    this.setState({ detailDialogOpen: true, selectedObject: selectedObject })
    this.setState({
      boxAddress: (selectedObject.address_line_1 + ' '
        + selectedObject.address_line_2 + ','
        + selectedObject.city + ', '
        + selectedObject.state + ' '
        + selectedObject.zip + '')
    })
  }
  handlePUcodeClose = (event) => {
    event.preventDefault();
    this.setState({ detailDialogOpen: false, selectedObject: null })
  }
  handlePrintReceipt = () => {
    this.setState({ detailDialogOpen: false, printDialogOpen: true })
    setTimeout(() => {
      window.print();
      this.setState({ printDialogOpen: false, detailDialogOpen: false, selectedObject: null })
    }, 100);
  }

  handleInputChange = (event) => {
    this.setState({ queryId: event.target.value });
    TransactionFilterObj.group_id = event.target.value
    this.BindGrid();
  };

  fetchSuggestions = async () => {
    try {
      const result = fetch(`${process.env.REACT_APP_BASEURL}groups/search`, {
        method: "GET",
        withCredentials: true,
        headers: {
          Authorization:
            "Bearer " +
            JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
              .jwtToken,
          "Content-Type": "application/json",
        },
      }
      );
      result
        .then((result) => {
          result.json().then((resLocation) => {
            this.setState({ groups: resLocation && resLocation.data })
          })
        })
    } catch (error) {
      console.error("Error fetching groups:", error);
    }
  };

  render() {
    const {classes, t} = this.props;
    return (
      <Paper id="react-no-print" className={classes.root}>
        {
          this.state.loader ?
            <div className={classes.spinner}>
              <img className={classes.spinnerImage} src={spinner} alt="loading" />
            </div> :
            null
        }
        <div id="react-no-print">
          <div id="react-no-print">
            <Dialog
              open={this.state.detailDialogOpen || false}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              PaperProps={{
                style: { borderRadius: '5px', maxWidth: '100%', width: '60%' }
              }}
            >
              <DialogTitle id="alert-dialog-title">{t("Report.OutForDelivery.Popup.PickedUpBy")}</DialogTitle>
              <DialogContent>
                <Table aria-labelledby="tableTitle">
                  <TableHead>
                    <TableRow>
                      <TableCell className={classes.padding10px} sx={{ color: 'rgba(0, 0, 0, 0.54)' }}>{t("Report.OutForDelivery.Popup.FirstName")}</TableCell>
                      <TableCell className={classes.padding10px} sx={{ color: 'rgba(0, 0, 0, 0.54)' }}>{t("Report.OutForDelivery.Popup.LastName")}</TableCell>
                      <TableCell className={classes.padding10px} sx={{ color: 'rgba(0, 0, 0, 0.54)' }}>{t("Report.OutForDelivery.Popup.ContactlessPickup")}</TableCell>
                      <TableCell className={classes.padding10px} sx={{ color: 'rgba(0, 0, 0, 0.54)' }}>{t("Report.OutForDelivery.Popup.DlNo")}</TableCell>
                      <TableCell className={classes.padding10px} sx={{ color: 'rgba(0, 0, 0, 0.54)' }}>{t("Report.OutForDelivery.Popup.Signature")}</TableCell>
                      <TableCell className={classes.padding10px} sx={{ color: 'rgba(0, 0, 0, 0.54)' }}>{t("Report.OutForDelivery.Popup.Picture")}</TableCell>
                      <TableCell className={classes.padding10px} sx={{ color: 'rgba(0, 0, 0, 0.54)' }}>{t("Report.OutForDelivery.Popup.Relationship")}</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {
                      this.state.selectedObject !== null ?
                        <TableRow>
                          <TableCell className={classes.padding10px} >{this.state.selectedObject.pfirst_name ? this.state.selectedObject.pfirst_name : ''}</TableCell>
                          <TableCell className={classes.padding10px}>{this.state.selectedObject.plast_name ? this.state.selectedObject.plast_name : ''}</TableCell>
                          <TableCell className={classes.padding10px}>{this.state.selectedObject.iscontactlessactivated === true ? 'Yes' : 'No'}</TableCell>
                          <TableCell className={classes.padding10px}>{this.state.selectedObject.pdrivers_license_no ? this.state.selectedObject.pdrivers_license_no : ''}</TableCell>
                          <TableCell className={classes.padding10px}><img style={{ borderRadius: '0%', width: '230px', height: '150px' }} alt="" src={(this.state.selectedObject.psignature_url !== null && this.state.selectedObject.psignature_url !== '') ? this.state.selectedObject.psignature_url : '/static/dashboard/global_assets/images/placeholders/no-image.svg'} /></TableCell>
                          <TableCell className={classes.padding10px}><Avatar style={{ borderRadius: '0%', width: '150px', height: '150px' }} alt="" src={(this.state.selectedObject.ppicture_url !== null && this.state.selectedObject.ppicture_url !== '') ? this.state.selectedObject.ppicture_url : '/static/dashboard/global_assets/images/placeholders/no-image.svg'} /></TableCell>
                          <TableCell className={classes.padding10px}>{this.state.selectedObject.relationship ? this.state.selectedObject.relationship.replace('_', ' ').replace('_', ' ') : ''}</TableCell>
                        </TableRow>
                        :
                        <TableRow>
                          <TableCell colSpan={5}>{t("Report.OutForDelivery.NoDataFound")}</TableCell>
                        </TableRow>
                    }

                  </TableBody>
                </Table>
              </DialogContent>
              <DialogActions>
                <Button onClick={(e) => { this.handlePrintReceipt(e) }} color="primary" className={classes.primaryButton}>
                  {t("Report.OutForDelivery.Popup.PrintReceiptButton")}
                </Button>
                <Button onClick={(e) => { this.handlePUcodeClose(e) }} color="primary" className={classes.primaryButton}>
                  {t("Report.OutForDelivery.Popup.CloseButton")}
                </Button>
              </DialogActions>
            </Dialog>
          </div>
          <div>
            <Dialog
              open={this.state.printDialogOpen || false}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              fullWidth={true}
              PaperProps={{
                style: { maxWidth: '700px', maxHeight: '100%' }
              }}
            >
              <DialogTitle id="alert-dialog-title">{t("Report.OutForDelivery.Receipt.PickedUpReceipt")}</DialogTitle>
              <DialogContent>
                <Table aria-labelledby="tableTitle">
                  {
                    this.state.selectedObject !== null ?
                      (<TableBody>
                        <TableRow className={classes.rowheight}>
                          <TableCell>{t("Report.OutForDelivery.Receipt.PharmacyName")}:</TableCell>
                          <TableCell>{this.state.selectedObject.store}</TableCell>
                        </TableRow>
                        <TableRow className={classes.rowheight}>
                          <TableCell>{t("Report.OutForDelivery.Receipt.KioskName")}:</TableCell>
                          <TableCell>{this.state.selectedObject.box}</TableCell>
                        </TableRow>
                        <TableRow className={classes.rowheight}>
                          <TableCell>{t("Report.OutForDelivery.Receipt.Address")}:</TableCell>
                          <TableCell>{this.state && this.state.boxAddress}</TableCell>
                        </TableRow>
                        <TableRow className={classes.rowheight}>
                          <TableCell>{t("Report.OutForDelivery.Receipt.PickupOrder")}:</TableCell>
                          <TableCell>{this.state.selectedObject.pucode}</TableCell>
                        </TableRow>
                        <TableRow className={classes.rowheight}>
                          <TableCell>{t("Report.OutForDelivery.Receipt.PickupDate")}:</TableCell>
                          <TableCell>{this.state.selectedObject.pickupdate ? this.convertToTimeZone(this.state.selectedObject.pickupdate) : ''}</TableCell>
                        </TableRow>
                        <TableRow className={classes.rowheight}>
                          <TableCell>{t("Report.OutForDelivery.Receipt.StockDate")}:</TableCell>
                          <TableCell>{this.state.selectedObject.stockeddate ? this.convertToTimeZone(this.state.selectedObject.stockeddate) : ''}</TableCell>
                        </TableRow>
                        <TableRow className={classes.rowheight}>
                          <TableCell>{t("Report.OutForDelivery.Receipt.PatientName")}:</TableCell>
                          <TableCell>{this.state.selectedObject.username}</TableCell>
                        </TableRow>
                        <TableRow className={classes.rowheight}>
                          <TableCell style={{ borderBottom: 'none' }}><b>{t("Report.OutForDelivery.Receipt.OrderDetail")}</b></TableCell>
                        </TableRow>
                        <TableRow className={classes.rowheight}>
                          <Table size="small" aria-label="a dense table">
                            {/* <TableHead> */}
                            <TableRow>
                              <TableCell>{t("Report.OutForDelivery.Receipt.PrescriptionNumber")}</TableCell>
                              <TableCell align="right">{t("Report.OutForDelivery.Receipt.RxNumber")}</TableCell>
                              <TableCell align="right">{t("Report.OutForDelivery.Receipt.FillID")}</TableCell>
                            </TableRow>
                            {/* </TableHead> */}
                            <TableBody>
                              {/* {rows.map((row) => ( */}
                              <TableRow className={classes.rowheight}>
                                <TableCell component="th" scope="row">
                                  {this.state.selectedObject.rxno}
                                </TableCell>
                                <TableCell align="right">{this.state.selectedObject.prescriptionnumber}</TableCell>
                                <TableCell align="right">{this.state.selectedObject.fillid}</TableCell>
                              </TableRow>
                              {/* ))} */}
                            </TableBody>
                          </Table>
                        </TableRow>
                        <TableRow className={classes.rowheight}>
                          <TableCell style={{ borderBottom: 'none' }}><b>{t("Report.OutForDelivery.Receipt.Signature")}</b></TableCell>
                        </TableRow>
                        <TableRow className={classes.rowheight}>
                          <TableCell><Avatar style={{ border: '1px solid rgba(224, 224, 224, 1)', borderRadius: '0%', width: '100%', height: '150px' }} alt="" src={(this.state.selectedObject.psignature_url !== null && this.state.selectedObject.psignature_url !== '') ? this.state.selectedObject.psignature_url : '/static/dashboard/global_assets/images/placeholders/no-image.svg'} /></TableCell>
                        </TableRow>
                        <TableRow className={classes.rowheight}>
                          <TableCell style={{ borderBottom: 'none' }}><b>{t("Report.OutForDelivery.Receipt.PickedUpBy")}</b></TableCell>
                        </TableRow>
                        <TableRow className={classes.rowheight}>
                          <TableCell>{t("Report.OutForDelivery.Receipt.FirstName")}:</TableCell>
                          <TableCell>{this.state.selectedObject.pfirst_name}</TableCell>
                        </TableRow>
                        <TableRow className={classes.rowheight}>
                          <TableCell>{t("Report.OutForDelivery.Receipt.LastName")}:</TableCell>
                          <TableCell>{this.state.selectedObject.plast_name}</TableCell>
                        </TableRow>
                        <TableRow className={classes.rowheight}>
                          <TableCell>{t("Report.OutForDelivery.Receipt.IDNo")}:</TableCell>
                          <TableCell>{this.state.selectedObject.pdrivers_license_no}</TableCell>
                        </TableRow>
                        <TableRow className={classes.rowheight}>
                          <TableCell><Avatar style={{ borderRadius: '0%', width: '60%', height: '150px' }} alt="" src={(this.state.selectedObject.ppicture_url !== null && this.state.selectedObject.ppicture_url !== '') ? this.state.selectedObject.ppicture_url : '/static/dashboard/global_assets/images/placeholders/no-image.svg'} /></TableCell>
                        </TableRow>
                      </TableBody>)
                      :
                      (<TableBody>
                        <TableRow>
                          <TableCell colSpan={5}>{t("Report.OutForDelivery.NoDataFound")}</TableCell>
                        </TableRow>
                      </TableBody>)
                  }
                </Table>
              </DialogContent>
            </Dialog>
          </div>
          <Box component="div">
            <Grid container direction={'row'} alignItems={'center'} justifyContent={'flex-end'} spacing={2} sx={{ mt: 0, ml: 0, width: '100%', p: '0% 2% 1%' }}>
              <Grid item xs={12} md={12} sx={{ textAlign: 'end' }}>
                <Tooltip key="single-edit" title={t("Report.OutForDelivery.ExportCSV")}>
                  <IconButton
                    style={{ marginRight: '0' }}
                    aria-label="ExportCSV"
                    disabled={this.state.isButtonDisabled}
                    onClick={() => { this.exportCSV() }}
                  >
                    <img alt="download" src={download} style={{ height: '32px', width: '32px', cursor: 'pointer' }} />
                  </IconButton>
                </Tooltip>
              </Grid>
            </Grid>
          </Box>
        </div>
        <Divider style={{ marginTop: '10px', height: '5px' }} />
        <div className={classes.tableWrapper}>
          <ILocalAGGrid
            columnDefs={[
              withDateColumnFilter({
                field: 'transaction_date',
                headerName: t("Report.OutForDelivery.TransactionDate"),
                colId: 'transaction_date',
                valueFormatter: (p) => p.value ? this.convertToTimeZone(p.value) : '',
              }),
              { field: 'firstname', headerName: t("Report.OutForDelivery.FirstName"), colId: 'firstname' },
              { field: 'lastname', headerName: t("Report.OutForDelivery.LastName"), colId: 'lastname' },
              { field: 'store', headerName: t("Report.OutForDelivery.Store"), colId: 'store' },
              { field: 'box', headerName: t("Report.OutForDelivery.Location"), colId: 'box' },
              {
                field: 'deliverytype',
                headerName: t("Report.OutForDelivery.DeliverType"),
                colId: 'deliverytype',
                valueFormatter: (p) => getTypeByLang(p.value, t),
              },
              { field: 'rxno', headerName: t("Report.OutForDelivery.RxHash"), colId: 'rxno' },
              { field: 'fillid', headerName: t("Report.OutForDelivery.FillID"), colId: 'fillid' },
              { field: 'prescriptionnumber', headerName: t("Report.OutForDelivery.PrescriptionNumber"), colId: 'prescriptionnumber' },
              { field: 'pucode', headerName: t("Report.OutForDelivery.PUCode"), colId: 'pucode' },
              { field: 'ndccode', headerName: t("Report.OutForDelivery.NDCCode"), colId: 'ndccode' },
              { field: 'drugname', headerName: t("Report.OutForDelivery.DrugName"), colId: 'drugname' },
              { field: 'qty', headerName: t("Report.OutForDelivery.Qty"), colId: 'qty' },
              {
                field: 'price',
                headerName: t("Report.OutForDelivery.AmountDue"),
                colId: 'price',
                valueFormatter: (p) => p.value ? '$' + parseFloat(p.value).toFixed(2) : '$0.00',
              },
              {
                field: 'isConsultRequested',
                headerName: t("Report.OutForDelivery.Consult"),
                colId: 'Consult',
                valueFormatter: (p) => (p.value ? 'Yes' : 'No'),
              },
              { field: 'username', headerName: t("Report.OutForDelivery.User"), colId: 'User' },
            ]}
            defaultColDef={getDefaultColDef()}
            rowModelType="serverSide"
            cacheBlockSize={TransactionFilterObj.pageSize || 10}
            paginationPageSize={TransactionFilterObj.pageSize || 10}
            paginationPageSizeSelector={[10, 20, 25]}
            rowHeight={40}
            getRowId={this.getRowId}
            onGridReady={this.onGridReady}
            onPaginationChanged={this.onPaginationChanged}
          />
          </div>
      </Paper>
    );
  }
}

OutOfDelivery.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(withTranslation()(OutOfDelivery));



// WEBPACK FOOTER //
// ./src/components/Delivery-Report/out-of-delivery.js